import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Marker2 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={forwardedRef}>
    <path
      d="M10 18.5C10 18.5 16.2609 12.9348 16.2609 8.76087C16.2609 5.30309 13.4578 2.5 10 2.5C6.54222 2.5 3.73914 5.30309 3.73914 8.76087C3.73914 12.9348 10 18.5 10 18.5Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M12.0003 8.50013C12.0003 9.6047 11.1048 10.5001 10.0003 10.5001C8.89569 10.5001 8.00026 9.6047 8.00026 8.50013C8.00026 7.39556 8.89569 6.50013 10.0003 6.50013C11.1048 6.50013 12.0003 7.39556 12.0003 8.50013Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
))

export default Marker2
